import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import { Spinner } from "./components/ui";
import { LoginApoderado } from "./pages/LoginApoderado";
import { LoginAdmin } from "./pages/LoginAdmin";
import { VerifyMagicLink } from "./pages/VerifyMagicLink";
import { ActivarCuenta } from "./pages/ActivarCuenta";
import { AdminLayout } from "./pages/admin/AdminLayout";
import { Dashboard } from "./pages/admin/Dashboard";
import { Alumnos } from "./pages/admin/Alumnos";
import { CargaMasiva } from "./pages/admin/CargaMasiva";
import { Apoderados } from "./pages/admin/Apoderados";
import { Cursos } from "./pages/admin/Cursos";
import { Cuotas } from "./pages/admin/Cuotas";
import { Gastos } from "./pages/admin/Gastos";
import { Configuracion } from "./pages/admin/Configuracion";
import { PortalApoderado } from "./pages/portal/PortalApoderado";

export function App() {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center">
        <Spinner label="Cargando…" />
      </div>
    );
  }

  if (!user || !profile) {
    return (
      <Routes>
        {/* Acceso de administración: ruta separada, sin enlaces desde el portal. */}
        <Route path="/admin" element={<LoginAdmin />} />
        {/* Canje del enlace mágico del apoderado. */}
        <Route path="/portal/entrar" element={<VerifyMagicLink />} />
        {/* Activación de cuenta del apoderado (registra correo + acceso). */}
        <Route path="/activar" element={<ActivarCuenta />} />
        {/* Portal público de apoderados (todo lo demás). */}
        <Route path="*" element={<LoginApoderado />} />
      </Routes>
    );
  }

  if (profile.rol === "apoderado") {
    return (
      <Routes>
        <Route path="/portal" element={<PortalApoderado />} />
        <Route path="*" element={<Navigate to="/portal" replace />} />
      </Routes>
    );
  }

  // Admin
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/alumnos" element={<Alumnos />} />
        <Route path="/carga-masiva" element={<CargaMasiva />} />
        <Route path="/apoderados" element={<Apoderados />} />
        <Route path="/cursos" element={<Cursos />} />
        <Route path="/cuotas" element={<Cuotas />} />
        <Route path="/gastos" element={<Gastos />} />
        <Route path="/configuracion" element={<Configuracion />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
